<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Cuenta</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Cuenta</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="container-fluid">
        <form [formGroup]="form">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.Nombre}}</mat-label>
                        <input type="text" matInput formControlName="nombre">
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.NroCliente}}</mat-label>
                        <input type="text" matInput formControlName="nroCliente">
                    </mat-form-field>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 mt-2"
                    [hidden]="c.mensajeBloqueo == null || c.status == null">
                    <p [ngClass]="c.status != null && (c.status.length) ? 'status_cuenta_color_'+c.status : ''">
                        {{c.mensajeBloqueo}}</p>
                </div>


                
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Telefono}}</mat-label>
                        <input numbersOnly type="text" matInput formControlName="telefono">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                        (click)="clearInput('telefono')">
                        <mat-icon color="accent-darker">close</mat-icon>
                    </button>                
                    </mat-form-field>
                </div>
                
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Email}}</mat-label>
                        <input type="email" matInput formControlName="email">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                        (click)="clearInput('email')">
                        <mat-icon color="accent-darker">close</mat-icon>
                    </button>  
                    <mat-error *ngIf="form.get('email').errors?.email && form.get('email').touched">
                        El correo electrónico no es válido.
                    </mat-error>              
                    </mat-form-field>
                </div>
                

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.SitioInternet}}</mat-label>
                        <input type="text" matInput formControlName="sitioInternet">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('sitioInternet')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>


                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.EmailOpcional}}</mat-label>
                        <input type="email" matInput formControlName="emailOpcional">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                        (click)="clearInput('emailOpcional')">
                        <mat-icon color="accent-darker">close</mat-icon>
                    </button>  
                    <mat-error *ngIf="form.get('emailOpcional').errors?.email && form.get('emailOpcional').touched">
                        El correo electrónico no es válido.
                    </mat-error>                
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.Cuit}}</mat-label>
                        <input type="text" matInput formControlName="cuit">
                    </mat-form-field>
                </div>



                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdCondicionPago}}</mat-label>
                        <input type="text" matInput formControlName="condicionPago">
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdRegion}}</mat-label>
                        <input type="text" matInput formControlName="idRegion">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdTaxClassification}}</mat-label>
                        <input type="text" matInput formControlName="taxClassification">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                        <input type="text" matInput formControlName="grupoCliente">
                    </mat-form-field>
                </div>


                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdDivision}}</mat-label>
                        <input type="text" matInput formControlName="idDivision">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.CodigoPostal}}</mat-label>
                        <input type="text" matInput formControlName="codigoPostal">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.Ciudad}}</mat-label>
                        <input type="text" matInput formControlName="ciudad">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.CalleNro}}</mat-label>
                        <input type="text" matInput formControlName="calleNro">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdZonaVendedor}}</mat-label>
                        <input type="text" matInput formControlName="zonaVendedor">
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.SalesOffice}}</mat-label>
                        <input type="text" matInput formControlName="idSalesOffice">
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdTipoCredito}}</mat-label>
                        <input type="text" matInput formControlName="tipoCredito">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.LimiteCredito}}</mat-label>
                        <input type="text" matInput [value]="form.get('limiteCredito').value | number : '1.3-3'">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.CreditoUtilizado}}</mat-label>
                        <input type="text" matInput [value]="form.get('creditoUtilizado').value | number : '1.3-3'">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.FechaVtoCredito}}</mat-label>
                        <input type="text" matInput formControlName="fechaVtoCredito">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.Status}}</mat-label>
                        <input type="text" matInput formControlName="status">
                    </mat-form-field>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.IdMoneda}}</mat-label>
                        <input type="text" matInput formControlName="idMoneda">
                    </mat-form-field>
                </div>




            </div>
        </form>

        <mat-tab-group>
            <mat-tab label="Distribuidores">
                <div class="container-fluid">
                    <div class="row align-items-center justify-content-evenly">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field color="accent-darker" appearance="standard">
                                <mat-label>{{Etiquetas.Buscar}}</mat-label>
                                <input matInput (keyup)="applyFilterCuentasDistribuidores($event)" #input>
                            </mat-form-field>

                            <div class="mat-table-cuentas-distribuidores">
                                <table mat-table matTableResponsive [dataSource]="dataSourceCuentasDistribuidores" matSort
                                    #matSortCuentasDistribuidores="matSort" matSortActive="nombre" matSortDirection="asc">

                                    <ng-container matColumnDef="acciones">
                                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                                        <td mat-cell *matCellDef="let d">
                                            <div>
                                                <button *ngIf="(isInRole('ADM') ||isInRole('ADMVENTAS') || isInRole('ADM LOCAL'))" 
                                                matTooltip="{{Tooltips.Editar}}" (click)="dialogCuentaDistribuidor(2,d)" mat-icon-button
                                                    color="primary-darker">
                                                    <mat-icon color="accent-darker">edit</mat-icon>
                                                </button>
                                            </div>
            
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nroClienteCuenta">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.NroClientePartner}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.nroClienteCuenta}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.Nombre}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.nombre}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ciudad">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.Ciudad}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.ciudad}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="calleNro">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CalleNro}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.calleNro}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nroClienteDistribuidor">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.NroCliente}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.nroClienteDistribuidor}}
                                        </td>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="funcionPartner">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.FuncionPartner}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.funcionPartner}}
                                        </td>
                                    </ng-container> -->

                                    <ng-container matColumnDef="codigoBodegaCoagra">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CodigoBodegaCoagra}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.codigoBodegaCoagra}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="codigoBodegaMyV">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CodigoBodegaMyV}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.codigoBodegaMyV}}
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsCuentasDistribuidores"></tr>
                                    <tr mat-row *matRowDef="let d; columns: displayedColumnsCuentasDistribuidores;">
                                    </tr>


                                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="displayedColumnsCuentasDistribuidores.length">
                                            {{Etiquetas.SinRegistros}}
                                        </td>
                                    </tr>
                                </table>

                                <mat-paginator #matPaginatorCuentasDistribuidores="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                    showFirstLastButtons>
                                </mat-paginator>
                            </div>


                        </div>

                    </div>

                </div>
            </mat-tab>
            <mat-tab label="Direcciones">
                <div class="container-fluid">
                    <div class="row align-items-center justify-content-evenly">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field color="accent-darker" appearance="standard">
                                <mat-label>{{Etiquetas.Buscar}}</mat-label>
                                <input matInput (keyup)="applyFilterDirecciones($event)" #input>
                            </mat-form-field>

                            <div class="mat-table-cuentas-direcciones">
                                <table mat-table matTableResponsive [dataSource]="dataSourceDirecciones" matSort
                                    #matSortDirecciones="matSort" matSortActive="calleNro" matSortDirection="asc">

                                    <ng-container matColumnDef="acciones">
                                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                                        <td mat-cell *matCellDef="let d">
                                            <div>
                                                <button *ngIf="(isInRole('ADM') ||isInRole('ADMVENTAS') || isInRole('ADM LOCAL'))" 
                                                matTooltip="{{Tooltips.Editar}}" (click)="dialogDireccion(2,d)" mat-icon-button
                                                    color="primary-darker">
                                                    <mat-icon color="accent-darker">edit</mat-icon>
                                                </button>
                                            </div>
            
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="idPais">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.Pais}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.idPais}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="provincia">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.Provincia}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.provincia}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ciudad">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.Ciudad}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.ciudad}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="calleNro">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CalleNro}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.calleNro}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="codigoPostal">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CodigoPostal}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.codigoPostal}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="direccionEnvio">
                                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.DireccionEnvio}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            <div>
                                                <mat-icon color="accent-darker">{{ d.direccionEnvio ?
                                                    'check_box' :
                                                    'check_box_outline_blank' }}
                                                </mat-icon>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="direccionFacturacion">
                                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.DireccionFacturacion}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            <div>
                                                <mat-icon color="accent-darker">{{ d.direccionFacturacion ?
                                                    'check_box' :
                                                    'check_box_outline_blank' }}
                                                </mat-icon>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nroClientePartner">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.NroClientePartner}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.nroClientePartner}}
                                        </td>
                                    </ng-container>


                                    <ng-container matColumnDef="funcionPartner">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.FuncionPartner}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.funcionPartner}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="codigoCoagra">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            {{Etiquetas.CodigoBodegaCoagra}}
                                        </th>
                                        <td mat-cell *matCellDef="let d">
                                            {{d.codigoCoagra}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                           Status
                                        </th>
                                        <td mat-cell *matCellDef="let c" class="status_cuenta" [matTooltip]="
                                        c.mensajeStatus.length
                                        ? c.mensajeStatus
                                        : ''"
                                            [ngClass]="c.status != null && (c.status.length) ? 'status_cuenta_color_'+c.status : ''">
                                            {{c.status}}
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDirecciones"></tr>
                                    <tr mat-row *matRowDef="let d; columns: displayedColumnsDirecciones;">
                                    </tr>


                                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                        <td class="mat-cell" [attr.colspan]="displayedColumnsDirecciones.length">
                                            {{Etiquetas.SinRegistros}}
                                        </td>
                                    </tr>
                                </table>

                                <mat-paginator #matPaginatorDirecciones="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                    showFirstLastButtons>
                                </mat-paginator>
                            </div>


                        </div>

                    </div>

                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarCuenta()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>